import { useEffect } from "react";
export function Logoutcheck({ }) {
    useEffect(()=>{
        
        const userInfo=localStorage.getItem('UserInfoTAC');
        let useInforDetails=JSON.parse(userInfo)    
        console.log(useInforDetails?.userRole);          
        if(useInforDetails?.userRole=="Employee"){
                //  window.location.href='/homepage'
                 window.location.href='/admin/homepage'
        }
        else if(useInforDetails?.userRole=="Admin"){
            //  window.location.href='/users'
             window.location.href='/admin/users'
        }
        else{
            //  window.location.href='/login'
             window.location.href='/admin/login'
        }
    
    },[])
    return (<>
       
    </>)
}